import styled, { css } from "styled-components"

export const createStyledText = ({ theme, variant = "body1", weight = "regular", color = "normal" }) => {
  const typo = theme.typography[variant];
  const fontWeight = typo.fontWeight[weight] || typo.fontWeight.regular;
  const fontSize = typo.fontSize;
  const lineHeight = typo.lineHeight;
  const themeColor = ["error", "warning", "info", "success"].includes(color)
    ? theme.colors.status[color]
    : theme.colors.text[color];
  const textColor = themeColor || color || theme.colors.text.normal;

  return css`
    font-size: ${fontSize}px;
    line-height: ${lineHeight}px;
    font-weight: ${fontWeight};
    color: ${textColor};
  `;
};

const StyledText = styled.span`
  ${({ theme, $variant, $weight, $color }) => 
    createStyledText({ 
      theme, 
      variant: $variant, 
      weight: $weight, 
      color: $color 
    })
  }
`;

const Text = ({ as = "span", variant, weight, color, children, ...props }) => {
  return (
    <StyledText
      as={as}
      $variant={variant}
      $weight={weight}
      $color={color}
      {...props}
    >
      {children}
    </StyledText>
  );
};

export default Text;
